export const LATEST_ORDER_LIMIT = 5;
